export default __webpack_public_path__ + "static/media/Female1.bf8fb024.png";